import {
  GET_TAGS_SUCCESS,
  CREATE_TAG_SUCCESS,
  UPDATE_TAG_SUCCESS,
  DELETE_TAG_SUCCESS,
} from './tag.types';

const initialState = {
  tags: [],
};

export const tagReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_TAGS_SUCCESS:
      return { ...state, tags: action.payload };
    case CREATE_TAG_SUCCESS:
      return { ...state, tags: [...state.tags, action.payload] };
    case UPDATE_TAG_SUCCESS:
      return {
        ...state,
        tags: state.tags.map((t) =>
          t._id === action.payload._id ? action.payload : t
        ),
      };
    case DELETE_TAG_SUCCESS:
      return {
        ...state,
        tags: state.tags.filter((t) => t._id !== action.payload),
      };
    default:
      return state;
  }
};
